import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Activity } from '../models';
import { environment } from 'src/environments/environment';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class ActivityService extends BaseApiService<Activity> {
  get cacheKey(): StorageKey {
    return StorageKey.activityServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    let url = `${environment.apiUrl}/activities`;
    if (id != null) {
      url = url + '/' + encodeURIComponent(id);
    }
    return url;
  }

  protected unparse(obj) {
    return Activity.unparse(obj);
  }

  protected parse(obj) {
    return Activity.parse(obj);
  }
}
